import * as React from "react";
import { FormEvent } from "react";
import { FormControl, Panel, FormGroup } from "react-bootstrap"

import { fakturaVerdi, fakturaVerdiFormattert } from "../Component/felt";
import { navigateToRoute } from "../Component/navigation";
import { IModelLaster } from "../domene";
import { appContext } from "../App/appContext";

import Models = Gf.Web.Models;

interface IOkonomiModell {
    // ReSharper disable once InconsistentNaming
    Fakturanumre: { [fakturaId: number]: number }
}

interface IOkonomiProps {
    model: Models.StartModell;
    laster: IModelLaster;
}

export class Okonomi extends React.Component<IOkonomiProps, IOkonomiModell> {

    constructor(modell: IOkonomiProps, private readonly parameterFetcher: (parameterSender: () => any) => void) {
        super(modell);
        this.state = {
            Fakturanumre: {}
        };
    }

    render() {
        return (this.props.model.Fakturaer.Rader.length === 0) ? null : <div>
            <h3>Til behandling</h3>
                   {this.props.model.Fakturaer.Rader.map((r, i) => {
                       const fakturaer = this.props.model.Fakturaer;
                       const fakturaId = r.EntitetId;
                       const fakturaNr = fakturaVerdi(fakturaer, r, Models.FakturaFeltType.FakturaNr);
                       const belop = fakturaVerdi(fakturaer, r, Models.FakturaFeltType.SumNetto);
                       const tekst = fakturaId ? "Faktura uten fakturanummer" : "Ufakturert";
                       const fakturaMottaker = fakturaVerdiFormattert(fakturaer, r, Models.FakturaFeltType.MottakerNavn, this.props.laster);
                       const onClick = (evt: any) => { if(fakturaId && evt.target.tagName !== "INPUT") { navigateToRoute(`/Faktura/${fakturaId}`); } };
                       const header = <b><span>{tekst} til {fakturaMottaker}</span></b>;
                       const className = `polisePanel${fakturaId ? " klikkbart" : ""}`;
                       return <Panel className={className} key={i} header={header} onClick={onClick}>
                        <table><tbody>
                          <tr>
                            <td className="startFelt">Antall poliser:</td><td className="startVerdi hoyre">{fakturaVerdiFormattert(fakturaer, r, Models.FakturaFeltType.AntallPoliser, this.props.laster)}</td>
                            <td className="startFelt">Fra dato:</td><td className="startVerdi hoyre">{fakturaVerdiFormattert(fakturaer, r, Models.FakturaFeltType.FraDato, this.props.laster)}</td>
                            <td className="startFelt">Brutto beløp:</td><td className="startVerdi hoyre">{fakturaVerdiFormattert(fakturaer, r, Models.FakturaFeltType.SumBrutto, this.props.laster)}</td>
                          </tr>
                          <tr>
                            <td className="startFelt">Antall kreditert:</td><td className="startVerdi hoyre">{fakturaVerdiFormattert(fakturaer, r, Models.FakturaFeltType.AntallKreditert, this.props.laster)}</td>
                            <td className="startFelt">Til dato:</td><td className="startVerdi hoyre">{fakturaVerdiFormattert(fakturaer, r, Models.FakturaFeltType.TilDato, this.props.laster)}</td>
                            <td className="startFelt">Netto beløp:</td><td className="startVerdi hoyre">{fakturaVerdiFormattert(fakturaer, r, Models.FakturaFeltType.SumNetto, this.props.laster)}</td>
                          </tr>
                          </tbody></table>
                      </Panel>;
                   })}
               </div>;
    }
}


// WEBPACK FOOTER //
// ./Scripts/React/Start/Okonomi.tsx